import * as React from 'react';
import './index.css';

const Intl = Mach.requireModule('Intl');

interface priceData {
  amount: number;
  displayAmount: string;
  currency: string;
  displayText: string;
  currencySign: string;
}

interface spuPromotionInfoData {
  originPrice?: priceData;
  finalPrice: priceData;
  promotionInfo?: string;
}

interface Props {
  data: spuPromotionInfoData;
}

export default class SpuPromotionInfo extends React.Component<Props, any> {
  // 去除隐形字符，用于验证字符分离是否正确
  // eslint-disable-next-line no-control-regex
  removeInvisibleCharacters = (str) => str?.replace(/[\u0000-\u001F\u007F-\u00A0\u200B-\u200F\u2028-\u202F\u2060-\u206F\uFEFF\uFFF0-\uFFFF]/g, '');

  renderFinalPrice(finalPrice: spuPromotionInfoData['finalPrice']) {
    const { displayText, currencySign, displayAmount } = finalPrice || {};
    const amountReg = /\d[.,\d]*\d/; // 允许以 . 或 , 为分隔符
    const amountFullMatchReg = new RegExp(`^${amountReg.source}$`);
    let amountText = '';
    if (currencySign && displayText?.includes(currencySign)) {
      amountText = displayText?.replace(currencySign, '').trim();
      // RTL字符串中存在一个用于标注文字显示方向的隐藏字符，判断时过滤掉
      if (amountFullMatchReg.test(this.removeInvisibleCharacters(amountText)) === false) {
        amountText = '';
      }
    }
    // 仅作兜底，不建议使用这种方式分离数字，用于currencySign与displayText中不统一或测试环境数据非正式等情况
    if (!amountText) {
      amountText = displayText.match(amountReg)?.[0] || displayAmount;
    }
    const content: JSX.RichTextContent = [
      {
        type: 'text',
        text: currencySign,
        color: '#f14e24',
        fontSize: 12,
        fontFamily: 'Keeta-Bold',
        fontWeight: '700'
      },
      {
        type: 'placeholder',
        width: 4
      },
      {
        type: 'text',
        text: amountText,
        color: '#f14e24',
        fontSize: 24,
        fontFamily: 'Keeta-Bold',
        fontWeight: '700'
      }
    ];
    if (Intl.isRTL?.()) {
      content.reverse();
    }
    return (
      <rich-text className="spuPromotionInfo-finalPrice" content={content} />
    );
  }

  renderOriginalPrice(originalPrice: NonNullable<spuPromotionInfoData['originPrice']>) {
    const { displayText } = originalPrice;
    const content: JSX.RichTextContent = [
      {
        type: 'text',
        text: displayText,
        textDecoration: 'line-through',
        color: '#808080',
        fontSize: 12,
        fontFamily: 'Keeta-Regular'
      }
    ];
    return (
      <rich-text className="spuPromotionInfo-originalPrice" content={content} />
    );
  }

  renderPromotionInfo(promotionInfo: spuPromotionInfoData['promotionInfo']) {
    return (
      <view class="spuPromotionInfo-promotionInfo">
        <image className="spuPromotionInfo-promotionInfo-bubble" src="assets://channel/promotion-bubble.png" autoRTL />
        <view className="spuPromotionInfo-promotionInfo-text">
          <text className="spuPromotionInfo-promotionInfo-text-content" content={promotionInfo} />
        </view>
      </view>
    );
  }

  render() {
    const { data } = this.props;
    const { finalPrice, originPrice, promotionInfo } = data || {};
    return (
      <view className="spuPromotionInfo-wrap">
        <view className="spuPromotionInfo-main">
          { finalPrice?.displayText && this.renderFinalPrice(finalPrice) }
          { promotionInfo && this.renderPromotionInfo(promotionInfo) }
        </view>
        <view className="spuPromotionInfo-sub">
          { originPrice?.displayText && this.renderOriginalPrice(originPrice) }
        </view>
      </view>
    );
  }
}
